import * as React from 'react';
import { DMButton, DMDiv } from '../Primitives';

type DMFormActionsProps = {
  isSubmitting?: boolean;
  isDisabled?: boolean;
  submitLabel: string;
  submittingLabel?: string;
  resetLabel?: string;
  onReset?: () => void;
  showReset?: boolean;
  submitType?: 'submit' | 'button';
  onSubmit?: () => void;
  submitClassName?: string;
  resetClassName?: string;
  className?: string;
};

export const DMFormActions = ({
  isSubmitting = false,
  isDisabled = false,
  submitLabel,
  submittingLabel = 'Please wait...',
  resetLabel = 'Reset',
  onReset,
  showReset,
  submitType = 'submit',
  onSubmit,
  submitClassName,
  resetClassName,
  className = '',
}: DMFormActionsProps) => {
  const shouldShowReset = showReset ?? !!onReset;

  return (
    <DMDiv
      className={`mt-auto flex shrink-0 justify-end gap-[1vw] pt-[3vh] ${className}`}
    >
      {shouldShowReset && (
        <DMButton
          type="button"
          onClick={onReset}
          className={
            resetClassName ||
            'h-[6.6vh] w-[14vw] rounded-full border border-gray-300 bg-white text-[1.85vh] font-semibold text-gray-950'
          }
        >
          {resetLabel}
        </DMButton>
      )}
      <DMButton
        type={submitType}
        onClick={onSubmit}
        disabled={isSubmitting || isDisabled}
        className={
          submitClassName ||
          'h-[6.6vh] w-[21vw] rounded-full bg-primary-main text-[1.85vh] font-semibold text-white disabled:opacity-60'
        }
      >
        {isSubmitting ? submittingLabel : submitLabel}
      </DMButton>
    </DMDiv>
  );
};
